
<div class="content ">
  @switch (type$ | async) {
    @case (notificationType.ERROR) {
      <div class="alert-error">
        <div class="alert-header" [ngClass]="{ withTitle: !!(parameters$ | async)?.title }">
          <i class="icon-alert-triangle"></i>
          <h2>{{ (parameters$ | async)?.title }}</h2>
          @if ((parameters$ | async)?.withCloseButton) {
            <button type="button" class="close-alert icon-x-circle1" aria-label="Close" (click)="closeAlertBand()"
              >
            </button>
          }
        </div>
        <div class="alert-content">
          @if (!!(parameters$ | async)?.icon) {
            <div class="alert-icon-container">
              <i [ngClass]="'icon-' + (parameters$ | async)?.icon"></i>
            </div>
          }
          <p class="alert-message">{{ message$ | async }}</p>
        </div>
        @if (!!action) {
          <div class="alert-action">
            <button (click)="getAction()">{{ action.text }}</button>
          </div>
        }
      </div>
    }
    <!-- INFO -->
    @case (notificationType.INFO) {
      <div class="alert-info ">
        <div class="alert-header" [ngClass]="{ withTitle: !!(parameters$ | async)?.title }">
          <i class="icon-info1"></i>
          <h2>{{ (parameters$ | async)?.title }}</h2>
          @if ((parameters$ | async)?.withCloseButton) {
            <button type="button" class="close-alert icon-x-circle1" aria-label="Close" (click)="closeAlertBand()"
              >
            </button>
          }
        </div>
        <div class="alert-content">
          @if (!!(parameters$ | async)?.icon) {
            <p class="alert-icon-container">
              <i [ngClass]="'icon-' + (parameters$ | async)?.icon"></i>
            </p>
          }
          <p class="alert-message">{{ message$ | async }}</p>
        </div>
        @if (!!action) {
          <div class="alert-action">
            <button (click)="getAction()">{{ action.text }}</button>
          </div>
        }
      </div>
    }
    <!-- WARNING -->
    @case (notificationType.WARNING) {
      <div class="alert-warning ">
        <div class="alert-header" [ngClass]="{ withTitle: !!(parameters$ | async)?.title }">
          <i class="icon-warning-circle"></i>
          <h2>{{ (parameters$ | async)?.title }}</h2>
          @if ((parameters$ | async)?.withCloseButton) {
            <button type="button" class="close-alert icon-x-circle1" aria-label="Close" (click)="closeAlertBand()"
              >
            </button>
          }
        </div>
        <div class="alert-content">
          @if (!!(parameters$ | async)?.icon) {
            <span class="alert-icon-container"><i [ngClass]="'icon-' + (parameters$ | async)?.icon"></i></span>
          }
          <span class="alert-message" [innerHTML]="(message$ | async)"></span> <br>
          <!-- <span> Need help? You may <a [routerLink]="['/contact']" routerLinkActive="router-link-active">contact us</a></span> -->
        </div>
        <form class="input-form" #inputForm="ngForm" (ngSubmit)="getAction()">
          @if ((parameters$ | async)?.withInput) {
            <input type="text" [(ngModel)]="inputValue" pattern="\d{4,}"
              name="inputValue" minlength="4" (keyup.enter)="getAction()" required>
          }
          @if ((parameters$ | async)?.withInput && showInputErrorMessage) {
            <span class="error">Code incorrect</span>
          }
        </form>
        @if (!!action) {
          <div class="alert-action">
            <!-- DEBUG -->
            <!-- <span>{{inputForm?.invalid}}</span> -->
            <button (click)="getAction()" [disabled]="(parameters$ | async)?.withInput && inputForm?.invalid">{{action.text}}</button>
          </div>
        }
        @if (!!action) {
          <div class="alert-action">
            <button (click)="getAction()">{{ action.text }}</button>
          </div>
        }
      </div>
    }
  }
</div>
<!-- </div> -->
